/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
/* eslint valid-typeof: "error" */
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Typography, Popover, Box } from '@material-ui/core';
import Label from 'src/components/Label';

MouseOverPopover.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string
};

export default function MouseOverPopover({ data, title }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Label
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {data[0][title]}...,
      </Label>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none'
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            boxShadow: 'none',
            borderRadius: 0
          }
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box
          sx={{
            position: 'relative',
            mt: '10px',
            '&::before': {
              backgroundColor: 'white',
              content: '""',
              display: 'block',
              position: 'absolute',
              width: 12,
              height: 12,
              top: -6,
              transform: 'rotate(45deg)',
              left: 'calc(50% - 6px)'
            }
          }}
        />
        {data.map((a) => (
          <Typography fontSize="12px" key={a.id} sx={{ p: 1, backgroundColor: 'white' }}>
            {a[title]}
          </Typography>
        ))}
      </Popover>
    </div>
  );
}
